import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AdministrativeService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  setup(data: any) {
    return this.http.post("http://localhost:8080/sdkadiq/setup", data, {responseType: 'text'});
  }



}
